import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointListNetworkCell } from './charge-point-list-network.cell';
import { ChargePointListNetworkHeader } from './charge-point-list-network.header';

export const ChargePointListNetworkColumn: IdentifiedColumnDef<
  GatewayChargePointModel,
  GatewayChargePointModel['network']
> = {
  enableSorting: false,
  header: ChargePointListNetworkHeader,
  cell: ChargePointListNetworkCell,
  meta: { maxWidth: '140px' },
};
